export const TRADES_AREAS = [
  { slug: 'bristol', name: 'Bristol', region: 'City of Bristol' },
  { slug: 'bath', name: 'Bath', region: 'Bath and North East Somerset' },
  { slug: 'taunton', name: 'Taunton', region: 'Somerset' },
  { slug: 'yeovil', name: 'Yeovil', region: 'Somerset' },
  { slug: 'weston-super-mare', name: 'Weston-super-Mare', region: 'North Somerset' },
  { slug: 'gloucester', name: 'Gloucester', region: 'Gloucestershire' },
  { slug: 'cheltenham', name: 'Cheltenham', region: 'Gloucestershire' },
  { slug: 'stroud', name: 'Stroud', region: 'Gloucestershire' },
  { slug: 'swindon', name: 'Swindon', region: 'Wiltshire' },
  { slug: 'salisbury', name: 'Salisbury', region: 'Wiltshire' },
  { slug: 'weymouth', name: 'Weymouth', region: 'Dorset' },
  { slug: 'bournemouth', name: 'Bournemouth', region: 'Dorset' },
  { slug: 'poole', name: 'Poole', region: 'Dorset' },
  { slug: 'cardiff', name: 'Cardiff', region: 'South Wales' },
  { slug: 'newport', name: 'Newport', region: 'South Wales' },
  { slug: 'london', name: 'London', region: 'Greater London' },
  { slug: 'manchester', name: 'Manchester', region: 'Greater Manchester' },
  { slug: 'norwich', name: 'Norwich', region: 'Norfolk' },
  { slug: 'edinburgh', name: 'Edinburgh', region: 'Scotland' },
  { slug: 'glasgow', name: 'Glasgow', region: 'Scotland' },
  { slug: 'birmingham', name: 'Birmingham', region: 'West Midlands' },
  { slug: 'sunderland', name: 'Sunderland', region: 'Tyne and Wear' },
  { slug: 'worcester', name: 'Worcester', region: 'Worcestershire' },
  { slug: 'leeds', name: 'Leeds', region: 'West Yorkshire' },
  { slug: 'liverpool', name: 'Liverpool', region: 'Merseyside' },
  { slug: 'newcastle-upon-tyne', name: 'Newcastle upon Tyne', region: 'Tyne and Wear' },
  { slug: 'sheffield', name: 'Sheffield', region: 'South Yorkshire' },
  { slug: 'nottingham', name: 'Nottingham', region: 'Nottinghamshire' },
  { slug: 'belfast', name: 'Belfast', region: 'Northern Ireland' },
  { slug: 'aberdeen', name: 'Aberdeen', region: 'Scotland' },
  { slug: 'southampton', name: 'Southampton', region: 'Hampshire' },
  { slug: 'brighton', name: 'Brighton', region: 'East Sussex' },
  { slug: 'oxford', name: 'Oxford', region: 'Oxfordshire' },
  { slug: 'plymouth', name: 'Plymouth', region: 'Devon' },
  { slug: 'cambridge', name: 'Cambridge', region: 'Cambridgeshire' },
  { slug: 'derby', name: 'Derby', region: 'Derbyshire' },
  { slug: 'hull', name: 'Hull', region: 'East Yorkshire' },
  { slug: 'swansea', name: 'Swansea', region: 'South Wales' },
  { slug: 'stoke-on-trent', name: 'Stoke-on-Trent', region: 'Staffordshire' },
  { slug: 'middlesbrough', name: 'Middlesbrough', region: 'North Yorkshire' },
  { slug: 'reading', name: 'Reading', region: 'Berkshire' },
  { slug: 'northampton', name: 'Northampton', region: 'Northamptonshire' },
  { slug: 'coventry', name: 'Coventry', region: 'West Midlands' },
  { slug: 'ipswich', name: 'Ipswich', region: 'Suffolk' }
];

const bySlug = new Map(TRADES_AREAS.map((a) => [a.slug, a]));

export function getTradesAreaBySlug(slug) {
  if (!slug || typeof slug !== 'string') return undefined;
  return bySlug.get(slug.toLowerCase());
}

export function groupTradesByRegion() {
  const map = new Map();
  for (const a of TRADES_AREAS) {
    if (!map.has(a.region)) map.set(a.region, []);
    map.get(a.region).push(a);
  }
  return map;
}
